import { classNamePrefix } from '../globals';

export function renderListButton (buttons: HTMLButtonElement[]) {
    const className = classNamePrefix + '-list-button';

    const listElement = document.createElement('ul');
    listElement.classList.add(className);

    buttons.forEach((button) => {
        const itemElement = document.createElement('li');
        itemElement.classList.add(className + '__item');
        itemElement.appendChild(button);

        listElement.appendChild(itemElement)
    });

    return listElement;
}